/**
 * UcFormParts — общие кирпичи форм UC-панели «Юникоины» (screen-22,
 * эталон js:61-68): FCell — ячейка ecell с klbl-лейблом; SelBtn — селектор
 * te-numbtn «значение ▾» с приглушённым плейсхолдером (js:61-63); opItems —
 * пункты Dropdown оператора с балансом в meta (opDrop js:64-66; минус у
 * отрицательного баланса — та же идиома, что строки Балансов); CheckIco —
 * галочка кнопки «Провести/Обменять» (iCheck js:11).
 */
import type { MouseEvent, ReactNode } from "react";
import type { DropdownItem } from "../../components/shared";
import type { UcBalanceRow } from "../../api/ucTypes";
import { fmtUC, NB } from "./ucFmt";
import cfg from "./config.module.css";
import dcss from "./dicts.module.css";
import ucss from "./uc.module.css";

/** Ячейка формы: лейбл-капс + контрол (эталон cell js:67-68). */
export function FCell({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className={ucss.ecell}>
      <span className={cfg.klbl}>{label}</span>
      {children}
    </div>
  );
}

/** Селектор «значение ▾» (эталон selBtn js:61-63). value=null → плейсхолдер. */
export function SelBtn({ value, ph, onOpen }: {
  value: ReactNode | null;
  ph: string;
  onOpen: (e: MouseEvent<HTMLButtonElement>) => void;
}) {
  return (
    <button type="button" className={cfg.teNumbtn} onClick={onOpen}>
      <span className={ucss.tv}>{value ?? <span className={ucss.ph}>{ph}</span>}</span>
      <span className={`${dcss.chev} ${dcss.chev8}`}>▾</span>
    </button>
  );
}

/** Пункты Dropdown оператора: имя + баланс в meta (эталон opDrop js:64-66). */
export const opItems = (balances: UcBalanceRow[]): DropdownItem[] =>
  balances.map((b) => ({
    id: b.operator_id,
    label: b.operator_name,
    meta: `${b.balance < 0 ? "−" : ""}${fmtUC(b.balance)}${NB}UC`,
  }));

/** Галочка кнопки подтверждения (эталон iCheck js:11). */
export const CheckIco = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="square">
    <path d="M4 12l6 6L20 7" />
  </svg>
);
